import * as React from "react";
import { InternalLink } from "../common/Link";
import { Button, Divider, IconButton, Menu, MenuItem } from "@mui/material";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { useMenu } from "../common/useMenu";
import { UrlObject } from "url";
import { constNull, pipe } from "fp-ts/function";
import { array, option } from "fp-ts";
import {
    dashboardRoute,
    orgRoute,
    useOrganizationsWhereAdmin,
} from "../../routes/user";
import { useUser } from "../../utils/supabase/useUser";
import { queryStateData } from "../../utils/supabase/QueryState";
import { useAlertOnQueryError } from "../../hooks/useAlertOnQueryError";
import { useRouter } from "next/router";
import { messages } from "../../utils/i18n/i18n";
import { useTranslation } from "../../utils/i18n/lang";

interface Props {
    route: UrlObject;
    label: string;
}

export const UserSpaceSwitch = (p: Props) => {
    const menu = useMenu();
    const userO = useUser();
    const router = useRouter();

    const organizationsWhereAdmin = useOrganizationsWhereAdmin(
        option.isNone(userO)
    );
    useAlertOnQueryError(organizationsWhereAdmin.state);
    const organizations = queryStateData(organizationsWhereAdmin.state);

    const t = useTranslation(msg);

    return (
        <>
            <InternalLink href={p.route}>
                <Button>{p.label}</Button>
            </InternalLink>
            <IconButton size={"small"} onClick={menu.handleOpenBtnClick}>
                <UnfoldMoreIcon />
            </IconButton>

            <Menu
                {...menu.menuProps}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <MenuItem
                    onClick={() => {
                        menu.close();
                        router.push(dashboardRoute.route({}));
                    }}
                >
                    {pipe(
                        userO,
                        option.chain((user) => option.fromNullable(user.email)),
                        option.getOrElse(() => t.dashboard)
                    )}
                </MenuItem>
                {/*<Divider />*/}
                {/*<MenuItem onClick={handleClose}>*/}
                {/*    Event where admin (not from my org)*/}
                {/*</MenuItem>*/}
                <Divider />
                {pipe(
                    organizations,
                    option.fold(
                        constNull,
                        array.map((organization) => (
                            <MenuItem
                                key={organization.subdomain}
                                // TODO
                                // selected={
                                //     organization.subdomain ===
                                //     orgCtx.active.subdomain
                                // }
                                onClick={() => {
                                    menu.close();
                                    router.push(
                                        orgRoute.index.route({
                                            org: organization.subdomain,
                                        })
                                    );
                                }}
                            >
                                {organization.name}
                            </MenuItem>
                        ))
                    )
                )}
                {/*<MenuItem onClick={menu.close}>+ Create org</MenuItem> TODO */}
            </Menu>
        </>
    );
};

const msg = messages(
    {
        dashboard: "My account",
    },
    {
        cs: {
            dashboard: "Můj účet",
        },
    }
);
